import React, { useState, useRef, useEffect, useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import './css/MenuReg.css'
import './css/BaseMenuReg.css'
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import Editing1 from './images/MenuReg/Editing1.png'
import remove from './images/Inventory/delete.png'
import right from './images/right-arrow.png'
import Redeye1 from './images/Inventory/visible.png'
// import Editing1 from './images/MenuReg/Editing1.png'
// import Redeye1 from './images/MenuReg/Redeye1.png'
import Down from './images/MenuReg/chevron-down1.png'
import Search from './images/MenuReg/search1.png'
import Add1 from './images/MenuReg/Add1.png'
import AddCombo from './images/icons/AddCombo.png'
import Minus1 from './images/icons/minu1.png'
import rightarrow from './images/Mobile/Upload (1).png'
import uparrow from './images/Mobile/Upload.png'
import Delete from './images/icons/delete.png'
import AddVarientModel from './AddVarientModel';
import { faL } from '@fortawesome/free-solid-svg-icons';
import ModalImage from './ModelImage';
import { ToastContainer, toast } from 'react-toastify';
import { DBContext } from './DBContext'
import axios from 'axios'
import Select, { components } from 'react-select';
import io from 'socket.io-client';
import SideNavMob from './SideNavMob'
import NavBarMobile from './Mobile/NavBar'

function BaseMenuRegMob() {

    const api_base_url = process.env.REACT_APP_API_BASE_URL

    const { customerCode, logginedDB, sideNavState, sideNavStateFunc } = useContext(DBContext);

    const location = useLocation();

    const [Database, setDatabase] = useState(localStorage.getItem('DB'));
    const [imgCode, setImgCode] = useState(localStorage.getItem('imgCode'));
    const [company, setCompany] = useState(localStorage.getItem('Company'));
    const [loadingKitchen, setLoadingKitchen] = useState([]); // To track the loading state
    const [loadingSubKitchen, setLoadingSubKitchen] = useState([]);
    // //(loadingKitchen);

    const [kitchens, setKitchens] = useState(false)
    const [loadingTable, setLoadingTable] = useState(true); // To track the loading state

    // const [menuDelivery]
    const [item, setItem] = useState(() => {
        if (location.state === 'areaCancel' || location.state === 'tableCancel' || location.state === 'addonCancel') {
            return false
        } else return false
    })

    // useEffect(() => {
    //     // Connect to the WebSocket server
    //     const socket = io(api_base_url);
    //     socket.on('updateCategory', () => {
    //         handleGetCategories();
    //     });

    //     return () => {
    //         socket.disconnect();
    //     };
    // }, [api_base_url,logginedDB]);


    const socketRef = useRef(null);


    //   useEffect(() => {
    //     if (!logginedDB) return; // if not logged in, skip

    //     // connect socket
    //     socketRef.current = io(api_base_url, {
    //       transports: ["websocket"], // faster than polling
    //     });

    //     // make sure old listeners are removed before adding new ones
    //     socketRef.current
    //       .off("updateCategory")
    //       .on("updateCategory", handleGetCategories());

    //     // cleanup on unmount
    //     return () => {
    //       socketRef.current.disconnect();
    //     };
    //   }, [api_base_url, logginedDB]);



    useEffect(() => {
        if (!logginedDB) return;

        handleGetCategories();


        socketRef.current = io(api_base_url, {
            transports: ["websocket"],
        });

        // Event listeners
        const geteHandlerCategories = () => handleGetCategories();


        socketRef.current.on("connect", () => {
            console.log("Connected to server");
        });



        socketRef.current.on("updateCategory", geteHandlerCategories);

        return () => {
            if (socketRef.current) {
                socketRef.current.off("updateCategory", geteHandlerCategories);
                socketRef.current.disconnect();
            }
        };
    }, [api_base_url, logginedDB]);



    useEffect(() => {
        if (!logginedDB) return;

        // Run initial fetch
        handleGetCategories?.();
        //   handleGetKitchen?.();
        //   handleGetDiscount?.();

        socketRef.current = io(api_base_url, {
            transports: ["websocket"],
        });

        // Event listeners
        const handleCategoryEvent = () => {
            if (typeof handleGetCategories === "function") {
                handleGetCategories();
            }
        };

        //   const handleKitchenEvent = () => {
        //       if (typeof handleGetKitchen === "function") {
        //           handleGetKitchen();
        //       }
        //   };

        //   const handleDiscountEvent = () => {
        //       if (typeof handleGetDiscount === "function") {
        //           handleGetDiscount();
        //       }
        //   };

        socketRef.current.on("connect", () => {
            console.log("Connected to server");
        });

        socketRef.current.on("disconnect", () => {
            console.log("Disconnected from server");
        });

        socketRef.current.on("connect_error", (error) => {
            console.error("Connection error:", error);
        });

        socketRef.current.on("createdCategory", handleCategoryEvent);
        //   socketRef.current.on("updateKitchen", handleKitchenEvent);
        //   socketRef.current.on("updateDiscount", handleDiscountEvent);

        return () => {
            if (socketRef.current) {
                socketRef.current.off("createdCategory", handleCategoryEvent);
                //   socketRef.current.off("updateKitchen", handleKitchenEvent);
                //   socketRef.current.off("updateDiscount", handleDiscountEvent);
                socketRef.current.disconnect();
            }
        };
    }, [api_base_url, logginedDB]);


    const [category, setCategory] = useState(false)
    const [varients, setVarients] = useState(false)
    const [tableArea, setTableArea] = useState(false)
    const [addons, setAddons] = useState(false)
    const [addonsData, setAddonsData] = useState([])
    const [taxes, setTaxes] = useState(false)
    const [discount, setDiscount] = useState(false)
    const [kitchen, setKitchen] = useState(false)
    const [CategoryDbData, setCategoryDbData] = useState([])
    const [captain, setcaptain] = useState(false)

    const handleGetCategories = async () => {
        try {
            const response = await axios.get(`${api_base_url}/GetCategories/${logginedDB}`)
            if (response.status == 200) {
                setCategoryDbData(response.data.data)
            }
        } catch (error) {
            console.error("Error fetching Category:", error)
        }
    }

    const handleGetKitchen = async () => {
        try {
            const response = await axios.get(`${api_base_url}/GetKitchen/${logginedDB}`)
            if (response.status == 200) {
                setLoadingKitchen(response.data)
            }
        } catch (error) {
            //(error);
        }
    }

    const handleGetSubKitchen = async () => {
        try {
            const response = await axios.get(`${api_base_url}/GetSubKitchen/${logginedDB}`)
            if (response.status == 200) {
                setLoadingSubKitchen(response.data)
            }
        } catch (error) {
            //(error);
        }
    }

    const handleGetAddons = async () => {
        try {
            const response = await axios.get(`${api_base_url}/GetAddons/${logginedDB}`)
            if (response.status == 200) {
                setAddonsData(response.data)
                //(response.data);

            }
        } catch (error) {
            //(error);

        }
    }

    useEffect(() => {
        if (logginedDB) {
            handleGetKitchen()
            handleGetSubKitchen()
            handleGetCategories()
            handleGetAddons()
        }
    }, [api_base_url, logginedDB])

    const toItem = () => {
        setItem(!item)
    }
    const toCategory = () => {
        setCategory(!category)
    }
    const toAddons = () => {
        setAddons(!addons)
    }
    const toTable_Area = () => {
        setTableArea(!tableArea)
    }
    const toTaxes = () => {
        setTaxes(!taxes)
    }
    const toDiscount = () => {
        setDiscount(!discount)
    }
    const toKitchen = () => {
        setKitchens(!kitchens)
    }

    const [categoryParent, setCategoryParent] = useState(false)
    const [categoryCategory, setCategoryCategory] = useState(false)
    const [categoryGrouping, setCategoryGrouping] = useState(false)
    const [categoryMenu, setCategoryMenu] = useState(false)
    const toCategoryParent = () => {
        setCategoryParent(!categoryParent)
    }
    const toCategoryCategory = () => {
        setCategoryCategory(!categoryCategory)
    }
    const toCategoryGrouping = () => {
        setCategoryGrouping(!categoryGrouping)
    }
    const toCategoryMenu = () => {
        setCategoryMenu(!categoryMenu)
    }

    const [tableArea_Tables, setTableArea_Tables] = useState(false)
    const [tableArea_Areas, setTableArea_Areas] = useState(false)
    const toTableArea_Tables = () => {
        setTableArea_Tables(!tableArea_Tables)
    }
    const toTableArea_Areas = () => {
        setTableArea_Areas(!tableArea_Areas)
    }

    const [KitchenTab, setKitchenTab] = useState(false)
    const [SubKitchenTab, setSubKitchenTab] = useState(false)
    const toKitchenTab = () => {
        setKitchenTab(!KitchenTab)
    }
    const toSubKitchenTab = () => {
        setSubKitchenTab(!SubKitchenTab)
    }

    const navigate = useNavigate();

    useEffect(() => {
        // Process location.state only on initial mount
        if (location.state === 'areaCancel') {
            setTableArea(true);
            setTableArea_Areas(true);
            navigate(location.pathname, { replace: true, state: {} });
        } else if (location.state === 'tableCancel') {
            setTableArea(true);
            setTableArea_Tables(true);
            navigate(location.pathname, { replace: true, state: {} });
        } else if (location.state === 'addonCancel') {
            setAddons(true);
            navigate(location.pathname, { replace: true, state: {} });
        } else if (location.state === 'KitchenCancel') {
            setItem(false)
            setKitchens(true);
            setKitchenTab(true);
            navigate(location.pathname, { replace: true, state: {} });
        } else if (location.state === 'SubKitchenCancel') {
            setItem(false)
            setKitchens(true);
            setSubKitchenTab(true);
            navigate(location.pathname, { replace: true, state: {} });
        } else if (location.state === 'CategoryCancel') {
            setItem(false)
            setCategory(true);
            setCategoryParent(true);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, []);

    const toAddArea = () => {
        navigate('/tableareareg');
    };
    const toAddTable = () => {
        navigate('/tablereg')
    }
    const toAddCate = () => {
        navigate('/categoryreg')
    }
    const toAddItem = () => {
        navigate('/additem', {
            state: null
        })
    }

    const toAddAddon = () => {
        navigate('/AddonReg')
    }

    const toAddCaptain = () => {
        navigate('/CaptainReg');
    };



    // const [addVarient,setAddVarient] = useState(false)
    // const toAddVarient = () => {
    //     setAddVarient(true)
    // }

    const fileInputRef = useRef(null); // Ref for accessing file input element
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(false); // State to track loading indicator

    const handleUploadImg = () => {
        // Click the hidden file input element
        return fileInputRef.current.click();
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLoading(true); // Set loading to true when starting to load
            setImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setLoading(false); // Set loading to false when finished loading
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const toModifyItem = (root, id) => {
        if (root === 'item') {
            navigate('/AddItem', {
                state: id
            })
        } else if (root === 'categoryCategory') {
            navigate('/categoryreg')
        } else if (root === 'addon') {
            navigate('/addonReg', {
                state: 'toEdit'
            })
        } else if (root === 'area') {
            navigate('/tableareareg')
        } else if (root === 'Kitchen') {
            navigate('/Kitchen')
        }
    }

    const toDeleteItem = async (itemId) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");

        if (isConfirmed) {
            // try {
            //     const response = await fetch(`${api_base_url}/deleteItem/${itemId}`, {
            //         method: 'DELETE',
            //         headers: {
            //             'Content-Type': 'application/json',
            //         },
            //     });

            //     if (response.ok) {
            //         alert("Item deleted successfully.");
            //         // Refresh the items list or remove the item from the state
            //         setItems(prevItems => prevItems.filter(item => item.id !== itemId));
            //     } else {
            //         alert("Failed to delete the item.");
            //     }
            // } catch (error) {
            //     console.error('Error deleting item:', error);
            //     alert("An error occurred while deleting the item.");
            // }
        }
    };


    const parentRef = useRef(null);

    const [checkBoxSelectAll, setCheckBoxSelectAll] = useState(false)
    const handleCheckBoxSelectAll = (e) => {
        // //(e.target.checked);
        setCheckBoxSelectAll(e.target.checked)
        if (!checkBoxSelectAll) {
            setCheckBoxSelect(!checkBoxSelect)
        }
    }
    const [checkBoxSelect, setCheckBoxSelect] = useState(false)
    const handleCheckBoxSelect = (e) => {
        setCheckBoxSelect(e.target.checked)
        // //(e.target.checked);
        if (checkBoxSelectAll & e.target.checked === false) {
            setCheckBoxSelect(false)
            // //("");
        }
    }

    const [items, setItems] = useState([]);
    // //("helooitem",items);
    const [modalImage, setModalImage] = useState(null);

    const handleGetItems = async () => {
        try {
            const response = await fetch(`${api_base_url}/getItem/${logginedDB}/${customerCode}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            if (data.success) {
                setItems(data.data);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    useEffect(() => {
        if (customerCode) {
            handleGetItems();
        }

    }, [api_base_url, customerCode]);

    const [areaInfo, setAreaInfo] = useState([]);

    const [options, setOptions] = useState([])

    const [selectedOption, setSelectedOption] = useState(null)

    const handleChange = (option) => {
        setSelectedOption(option)
    }

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            fontSize: '.9em',
            // fontFamily: 'Poppins',
            textAlign: 'left',
            backgroundColor: state.isSelected ? '#c8cbcf' : '#FFF',
            color: state.isFocused ? '#000' : '#000',
            cursor: 'pointer', // Add cursor pointer on hover
            ':hover': {
                backgroundColor: '#c8cbcf',
                color: '#000',
            },
            ':active': {
                ...provided[':active'],
                backgroundColor: '#c8cbcf'
            }
        }),
        control: (provided, state) => ({
            ...provided,
            width: '100%',
            // height: '2.5rem',
            minHeight: '2.5rem',
            fontSize: '1em',
            borderRadius: selectedOption ? '0rem' : '.313rem', // Adjust this value as needed
            padding: '0', // Ensure no extra padding is added
            // border: 'none',
            fontWeight: '500',
            // color: 'white !important', // Set text color to white
            backgroundColor: 'transparent', // Change this to 'transparent' for a clear background
            boxShadow: 'none', // Remove the blue focus shadow
            border: selectedOption ? 'none' : '1px solid #ccc', // Optional: add custom border on focus
            borderBottom: selectedOption ? '1px solid #ccc' : '1px solid #ccc',
            '&:hover': {
                borderBottom: '1px solid #c8cbcf', // Optional: border on hover
            }
            // border: state.selectValue ? '1px solid #ccc' : 'none', // Apply full border if no selected option
            // borderBottom: state.selectValue ? '2px solid #c8cbcf' : '1px solid #ccc', // Apply bottom border when option is selected
            // '&:hover': {
            // 	border: state.selectValue ? '1px solid #ccc' : 'none', // Apply full border on hover if no option selected
            // 	borderBottom: state.selectValue ? '2px solid #c8cbcf' : 'none', // Apply bottom border on hover
            // }
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '2.25rem',
            minHeight: '2rem',
            padding: '0 8px', // Center the text vertically
            display: 'flex',
            //   color: '#fff',
            alignItems: 'center',
            fontSize: '.9rem'
        }),
        input: (provided) => ({
            ...provided,
            height: '2.25rem',
            minHeight: '2rem',
            margin: '0',
            padding: '0',
            //   color: '#fff',
            fontSize: '.9rem'
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '2.25rem',
            display: 'flex',
            alignItems: 'center',
            padding: '.5rem',
            paddingTop: '0',
            paddingBottom: '0'
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0', // Remove padding to center the icon
            width: '1rem',
            marginLeft: '.5rem',
            //   color: '#fff',
            cursor: 'pointer',
        }),
        placeholder: (provided) => ({
            ...provided,
            margin: '0',
            fontSize: '1em',
            //   color: '#fff',
            //   fontFamily: 'poppins'
        }),
        menu: (provided) => ({
            ...provided,
            //   borderRadius: '.1rem', // Adjust this value as needed
        }),
        singleValue: (provided) => ({
            ...provided,
            // color: 'white', // Set selected option text color to white
        }),
    };

    // //(areaInfo);
    const [tables, setTables] = useState([])


    const handleGetTables = async () => {

        try {
            const response = await axios.get(`${api_base_url}/GetTable/${selectedOption.value}/${logginedDB}`)
            if (response.status == 200) {
                setTables(response.data);
            }
        } catch (error) {
            //(error);
        }
    }

    useEffect(() => {
        if (selectedOption) {
            handleGetTables()
        }
    }, [selectedOption])

    const [areaTableLabels, setAreaTableLabels] = useState([]);
    // //(areaTableLabels);
    useEffect(() => {
        fetchData();
    }, [tableArea_Areas, tableArea_Tables]);

    const fetchData = async () => {
        try {
            const response = await fetch(`${api_base_url}/getAreaInfo/${logginedDB}`);
            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }
            const data = await response.json();
            // //(data);

            // // Process data to add tableLabels based on area.Tables
            // const processedData = data.map((area) => ({
            //     ...area,
            //     tableLabels: Array.from({ length: area.Tables }, (_, index) => `${area.AreaCode}${index + 1}`)
            // }));

            // // Extract tableLabels into a separate state
            // const labels = processedData.map((area) => area.tableLabels).flat(); // Flatten to get a single array
            // setAreaTableLabels(labels);

            const transformedData = data.map(area => ({
                value: area.Area_id,
                label: area.AreaName
            }));

            setOptions(transformedData);

            setAreaInfo(data);
        } catch (error) {
            console.error('Error fetching data:', error);
            // Handle error state, set fallback data, or display an error message
        }
    };

    const [modalImageMob, setModalImageMob] = useState(false)

    const handleImageClick = (imageUrl) => {
        if (items) {
            setModalImage(imageUrl)
            setModalImageMob(true)
        }
        // //(items);
    };

    const closeModal = () => {
        setModalImage(null);
    };

    const [sideNav, setSideNav] = useState(false)
    const handleSideNav = (state) => {
        setSideNav(state)
    }
    const [falseState, setFalseState] = useState(null)

    const [isActive, setIsActive] = useState(false)
    const [isActiveTable, setIsActiveTable] = useState(false)
    const [isActiveKitchen, setIsActiveKitchen] = useState(false)
    const [isActiveSubKitchen, setIsActiveSubKitchen] = useState(false)
    const [isActiveCategory, setIsActiveCategory] = useState(false)
    const [isActiveAddon, setIsActiveAddon] = useState(false)

    useEffect(() => {
        if (areaInfo) {
            // Initialize `isActive` state based on `areaInfo` when it changes
            const activeStates = areaInfo.reduce((acc, area) => {
                acc[area.Area_id] = area.Status === 1;
                return acc;
            }, {});
            setIsActive(activeStates);
        }
        if (tables) {
            // Initialize `isActive` state based on `areaInfo` when it changes
            const activeStates = tables.reduce((acc, table) => {
                acc[table.Table_id] = table.Status === 1;
                return acc;
            }, {});
            setIsActiveTable(activeStates);
        }
        if (loadingKitchen) {
            // /Initialize `isActive` state based on `areaInfo` when it changes
            const activeStates = loadingKitchen.reduce((acc, kitchen) => {
                acc[kitchen.Kitchen_id] = kitchen.Kitchen_is_Active === 1;
                return acc;
            }, {});
            setIsActiveKitchen(activeStates);
        }
        if (loadingSubKitchen) {
            // Initialize `isActive` state based on `areaInfo` when it changes
            const activeStates = loadingSubKitchen.reduce((acc, kitchen) => {
                acc[kitchen.Sub_Kitchen_id] = kitchen.Sub_Kitchen_is_Active === 1;
                return acc;
            }, {});
            setIsActiveSubKitchen(activeStates);
        }
        if (CategoryDbData) {
            // Initialize `isActive` state based on `areaInfo` when it changes
            const activeStates = CategoryDbData.reduce((acc, category) => {
                acc[category.id_category] = category.Status === 1;
                return acc;
            }, {});
            setIsActiveCategory(activeStates);
        }
        if (addons) {
            // Initialize `isActive` state based on `areaInfo` when it changes
            const activeStates = addonsData.reduce((acc, addon) => {
                acc[addon.id_addon] = addon.Status === 1;
                return acc;
            }, {});
            setIsActiveAddon(activeStates);
        }
    }, [areaInfo, tables, loadingKitchen, loadingSubKitchen, CategoryDbData, addons]);

    // Function to handle active/inactive toggle
    const handleIsActive = async (id, currentStatus) => {
        // Update the `isActive` state immediately
        setIsActive(prev => ({
            ...prev,
            [id]: !prev[id],
        }));

        try {
            // Make API request to update status
            const response = await axios.post(
                `${api_base_url}/updateAreaActive/${id}/${currentStatus === 1 ? 0 : 1}/${logginedDB}`
            );

            if (response.status === 200) {
                fetchData();
            }
        } catch (error) {
            console.error("Error updating user status:", error);

            // Revert the change in case of an error
            setIsActive(prev => ({
                ...prev,
                [id]: currentStatus === 1,
            }));
        }
    };

    const handleIsActiveTable = async (id, currentStatus) => {
        // Update the `isActive` state immediately
        setIsActiveTable(prev => ({
            ...prev,
            [id]: !prev[id],
        }));

        try {
            // Make API request to update status
            const response = await axios.post(
                `${api_base_url}/updateTableActive/${id}/${currentStatus === 1 ? 0 : 1}/${logginedDB}`
            );

            if (response.status === 200) {
                handleGetTables();
            }
        } catch (error) {
            console.error("Error updating user status:", error);

            // Revert the change in case of an error
            setIsActiveTable(prev => ({
                ...prev,
                [id]: currentStatus === 1,
            }));
        }
    };

    const handleIsActiveKitchen = async (id, currentStatus) => {
        // Update the `isActive` state immediately
        setIsActiveKitchen(prev => ({
            ...prev,
            [id]: !prev[id],
        }));

        try {
            // Make API request to update status
            const response = await axios.post(
                `${api_base_url}/updateKitchenActive/${id}/${currentStatus === 1 ? 0 : 1}/${logginedDB}`
            );

            if (response.status === 200) {
                handleGetKitchen();
            }
        } catch (error) {
            console.error("Error updating user status:", error);

            // Revert the change in case of an error
            setIsActiveKitchen(prev => ({
                ...prev,
                [id]: currentStatus === 1,
            }));
        }
    };

    const handleIsActiveSubKitchen = async (id, currentStatus) => {
        // Update the `isActive` state immediately
        setIsActiveSubKitchen(prev => ({
            ...prev,
            [id]: !prev[id],
        }));

        try {
            // Make API request to update status
            const response = await axios.post(
                `${api_base_url}/updateSubKitchenActive/${id}/${currentStatus === 1 ? 0 : 1}/${logginedDB}`
            );

            if (response.status === 200) {
                handleGetSubKitchen();
            }
        } catch (error) {
            console.error("Error updating user status:", error);

            // Revert the change in case of an error
            setIsActiveSubKitchen(prev => ({
                ...prev,
                [id]: currentStatus === 1,
            }));
        }
    };

    const handleIsActiveCategory = async (id, currentStatus) => {
        // Update the `isActive` state immediately
        setIsActiveCategory(prev => ({
            ...prev,
            [id]: !prev[id],
        }));

        try {
            // Make API request to update status
            const response = await axios.post(
                `${api_base_url}/updateCategoryActive/${id}/${currentStatus === 1 ? 0 : 1}/${logginedDB}`
            );

            if (response.status === 200) {
                handleGetCategories();
            }
        } catch (error) {
            console.error("Error updating user status:", error);

            // Revert the change in case of an error
            setIsActiveCategory(prev => ({
                ...prev,
                [id]: currentStatus === 1,
            }));
        }
    };

    const handleIsActiveAddon = async (id, currentStatus) => {
        // Update the `isActive` state immediately
        setIsActiveAddon(prev => ({
            ...prev,
            [id]: !prev[id],
        }));

        try {
            // Make API request to update status
            const response = await axios.post(
                `${api_base_url}/updateAddonActive/${id}/${currentStatus === 1 ? 0 : 1}/${logginedDB}`
            );

            if (response.status === 200) {
                handleGetAddons();
            }
        } catch (error) {
            console.error("Error updating user status:", error);

            // Revert the change in case of an error
            setIsActiveAddon(prev => ({
                ...prev,
                [id]: currentStatus === 1,
            }));
        }
    };

    const [selectedAreas, setSelectedAreas] = useState([])
    const [selectedTables, setSelectedTables] = useState([])
    const [selectedKitchen, setSelectedKitchen] = useState([])
    const [selectedSubKitchen, setSelectedSubKitchen] = useState([])
    const [selectedItems, setSelectedItems] = useState([])
    const [selectedCategory, setSelectedCategory] = useState([])
    const [selectedAddon, setSelectedAddon] = useState([])

    const [isCheckedAll, setIsCheckedAll] = useState(false);
    const [isCheckedAllTables, setIsCheckedAllTables] = useState(false);
    const [isCheckedAllKitchen, setIsCheckedAllKitchen] = useState(false);
    const [isCheckedAllSubKitchen, setIsCheckedAllSubKitchen] = useState(false);
    const [isCheckedAllItems, setIsCheckedAllItems] = useState(false);
    const [isCheckedAllCategory, setIsCheckedAllCategory] = useState(false);
    const [isCheckedAllAddon, setIsCheckedAllAddon] = useState(false);

    const [checkedArea, setCheckedArea] = useState(
        areaInfo.map(() => false) // Initialize all as unchecked
    );
    const [checkedTables, setCheckedTables] = useState(
        tables.map(() => false) // Initialize all as unchecked
    );
    const [checkedKitchen, setCheckedKitchen] = useState(
        loadingKitchen.map(() => false) // Initialize all as unchecked
    );
    const [checkedSubKitchen, setCheckedSubKitchen] = useState(
        loadingSubKitchen.map(() => false) // Initialize all as unchecked
    );
    const [checkedItems, setCheckedItems] = useState(
        items.map(() => false) // Initialize all as unchecked
    );
    const [checkedCategory, setCheckedCategory] = useState(
        CategoryDbData.length > 0 && CategoryDbData.map(() => false) // Initialize all as unchecked
    );
    const [checkedAddon, setCheckedAddon] = useState(
        addonsData.map(() => false) // Initialize all as unchecked
    );

    // Handle "Select All" checkbox
    const handleIsCheckedAll = (e, field) => {
        if (field === 'area') {
            const checked = e.target.checked;
            setIsCheckedAll(checked);
            setCheckedArea(areaInfo.map(() => checked)); // Set all checkboxes to the same state

            // Update selectedUsers with all or none
            if (checked) {
                setSelectedAreas(areaInfo.map((area) => area.Area_id)); // Add all user ids
            } else {
                setSelectedAreas([]); // Clear selection
            }
        } else if (field === 'table') {
            const checked = e.target.checked;
            setIsCheckedAllTables(checked);
            setCheckedTables(tables.map(() => checked)); // Set all checkboxes to the same state

            // Update selectedUsers with all or none
            if (checked) {
                setSelectedTables(tables.map((table) => table.Table_id)); // Add all user ids
            } else {
                setSelectedTables([]); // Clear selection
            }
        } else if (field === 'kitchen') {
            const checked = e.target.checked;
            setIsCheckedAllKitchen(checked);
            setCheckedKitchen(loadingKitchen.map(() => checked)); // Set all checkboxes to the same state

            // Update selectedUsers with all or none
            if (checked) {
                setSelectedKitchen(loadingKitchen.map((kitchen) => kitchen.Kitchen_id)); // Add all user ids
            } else {
                setSelectedKitchen([]); // Clear selection
            }
        } else if (field === 'subKitchen') {
            const checked = e.target.checked;
            setIsCheckedAllSubKitchen(checked);
            setCheckedSubKitchen(loadingSubKitchen.map(() => checked)); // Set all checkboxes to the same state

            // Update selectedUsers with all or none
            if (checked) {
                setSelectedSubKitchen(loadingSubKitchen.map((kitchen) => kitchen.Sub_Kitchen_id)); // Add all user ids
            } else {
                setSelectedSubKitchen([]); // Clear selection
            }
        } else if (field === 'items') {
            const checked = e.target.checked;
            setIsCheckedAllItems(checked);
            setCheckedItems(items.map(() => checked)); // Set all checkboxes to the same state

            // Update selectedUsers with all or none
            if (checked) {
                setSelectedItems(items.map((item) => item.id_productReg)); // Add all user ids
            } else {
                setSelectedItems([]); // Clear selection
            }
        } else if (field === 'category') {
            const checked = e.target.checked;
            setIsCheckedAllCategory(checked);
            setCheckedCategory(CategoryDbData.map(() => checked)); // Set all checkboxes to the same state

            // Update selectedUsers with all or none
            if (checked) {
                setSelectedCategory(CategoryDbData.map((category) => category.id_category)); // Add all user ids
            } else {
                setSelectedCategory([]); // Clear selection
            }
        } else if (field === 'addon') {
            const checked = e.target.checked;
            setIsCheckedAllAddon(checked);
            setCheckedAddon(addonsData.map(() => checked)); // Set all checkboxes to the same state

            // Update selectedUsers with all or none
            if (checked) {
                setSelectedAddon(addonsData.map((addon) => addon.id_addon)); // Add all user ids
            } else {
                setSelectedAddon([]); // Clear selection
            }
        }
    };

    // Handle individual checkboxes
    const handleIsChecked = (index, checked, field) => {
        if (field === 'area') {
            const updatedChecked = [...checkedArea];
            updatedChecked[index] = checked;
            setCheckedArea(updatedChecked);

            // Update "Select All" state if not all items are selected
            const allChecked = updatedChecked.every((item) => item);
            setIsCheckedAll(allChecked);

            // Update selectedUsers based on checked state
            const updatedSelectedUsers = [...selectedAreas];
            const userId = areaInfo[index].Area_id;

            if (checked) {
                // Add the user id if checked
                updatedSelectedUsers.push(userId);
            } else {
                // Remove the user id if unchecked
                const userIndex = updatedSelectedUsers.indexOf(userId);
                if (userIndex !== -1) {
                    updatedSelectedUsers.splice(userIndex, 1);
                }
            }

            setSelectedAreas(updatedSelectedUsers);
        } else if (field === 'table') {
            const updatedChecked = [...checkedTables];
            updatedChecked[index] = checked;
            setCheckedTables(updatedChecked);

            // Update "Select All" state if not all items are selected
            const allChecked = updatedChecked.every((item) => item);
            setIsCheckedAllTables(allChecked);

            // Update selectedUsers based on checked state
            const updatedSelectedUsers = [...selectedTables];
            const userId = tables[index].Table_id;

            if (checked) {
                // Add the user id if checked
                updatedSelectedUsers.push(userId);
            } else {
                // Remove the user id if unchecked
                const userIndex = updatedSelectedUsers.indexOf(userId);
                if (userIndex !== -1) {
                    updatedSelectedUsers.splice(userIndex, 1);
                }
            }

            setSelectedTables(updatedSelectedUsers);
        } else if (field === 'kitchen') {
            const updatedChecked = [...checkedKitchen];
            updatedChecked[index] = checked;
            setCheckedKitchen(updatedChecked);

            // Update "Select All" state if not all items are selected
            const allChecked = updatedChecked.every((item) => item);
            setIsCheckedAllKitchen(allChecked);

            // Update selectedUsers based on checked state
            const updatedSelectedUsers = [...selectedKitchen];
            const userId = loadingKitchen[index].Kitchen_id;

            if (checked) {
                // Add the user id if checked
                updatedSelectedUsers.push(userId);
            } else {
                // Remove the user id if unchecked
                const userIndex = updatedSelectedUsers.indexOf(userId);
                if (userIndex !== -1) {
                    updatedSelectedUsers.splice(userIndex, 1);
                }
            }

            setSelectedKitchen(updatedSelectedUsers);
        } else if (field === 'subKitchen') {
            const updatedChecked = [...checkedSubKitchen];
            updatedChecked[index] = checked;
            setCheckedSubKitchen(updatedChecked);

            // Update "Select All" state if not all items are selected
            const allChecked = updatedChecked.every((item) => item);
            setIsCheckedAllSubKitchen(allChecked);

            // Update selectedUsers based on checked state
            const updatedSelectedUsers = [...selectedSubKitchen];
            const userId = loadingSubKitchen[index].Sub_Kitchen_id;

            if (checked) {
                // Add the user id if checked
                updatedSelectedUsers.push(userId);
            } else {
                // Remove the user id if unchecked
                const userIndex = updatedSelectedUsers.indexOf(userId);
                if (userIndex !== -1) {
                    updatedSelectedUsers.splice(userIndex, 1);
                }
            }

            setSelectedSubKitchen(updatedSelectedUsers);
        } else if (field === 'items') {
            const updatedChecked = [...checkedItems];
            updatedChecked[index] = checked;
            setCheckedItems(updatedChecked);

            // Update "Select All" state if not all items are selected
            const allChecked = updatedChecked.every((item) => item);
            setIsCheckedAllItems(allChecked);

            // Update selectedUsers based on checked state
            const updatedSelectedUsers = [...selectedItems];
            const userId = items[index].id_productReg;

            if (checked) {
                // Add the user id if checked
                updatedSelectedUsers.push(userId);
            } else {
                // Remove the user id if unchecked
                const userIndex = updatedSelectedUsers.indexOf(userId);
                if (userIndex !== -1) {
                    updatedSelectedUsers.splice(userIndex, 1);
                }
            }

            setSelectedItems(updatedSelectedUsers);
        } else if (field === 'category') {
            const updatedChecked = [...checkedCategory];
            updatedChecked[index] = checked;
            setCheckedCategory(updatedChecked);

            // Update "Select All" state if not all items are selected
            const allChecked = updatedChecked.every((item) => item);
            setIsCheckedAllCategory(allChecked);

            // Update selectedUsers based on checked state
            const updatedSelectedUsers = [...selectedCategory];
            const userId = CategoryDbData[index].id_category;

            if (checked) {
                // Add the user id if checked
                updatedSelectedUsers.push(userId);
            } else {
                // Remove the user id if unchecked
                const userIndex = updatedSelectedUsers.indexOf(userId);
                if (userIndex !== -1) {
                    updatedSelectedUsers.splice(userIndex, 1);
                }
            }

            setSelectedCategory(updatedSelectedUsers);
        } else if (field === 'addon') {
            const updatedChecked = [...checkedAddon];
            updatedChecked[index] = checked;
            setCheckedAddon(updatedChecked);

            // Update "Select All" state if not all items are selected
            const allChecked = updatedChecked.every((item) => item);
            setIsCheckedAllAddon(allChecked);

            // Update selectedUsers based on checked state
            const updatedSelectedUsers = [...selectedAddon];
            const userId = addonsData[index].id_addon;

            if (checked) {
                // Add the user id if checked
                updatedSelectedUsers.push(userId);
            } else {
                // Remove the user id if unchecked
                const userIndex = updatedSelectedUsers.indexOf(userId);
                if (userIndex !== -1) {
                    updatedSelectedUsers.splice(userIndex, 1);
                }
            }

            setSelectedAddon(updatedSelectedUsers);
        }
    };

    function formatDate(inputDate) {
        const date = new Date(inputDate); // Parse the input date string

        // Extract day, month, and year
        const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }

    const [viewDetails, setViewDetails] = useState(null)
    const [isExiting, setIsExiting] = useState(false);

    const handleToView = (info) => {
        setViewDetails(info);
        setIsExiting(false);
    };

    const handleClose = () => {
        setIsExiting(true);
        setTimeout(() => {
            setViewDetails(null);
        }, 300); // Match the animation duration
    };

    const handleToDeleteItem = async () => {

        if (selectedItems.length > 0) {
            const userConfirmed = window.confirm(`Delete selected item?`);

            if (!userConfirmed) {
                return;
            }
            try {
                const response = await axios.post(`${api_base_url}/deleteItems/${logginedDB}`, selectedItems)
                if (response.status === 200) {
                    toast.success(`Successfully deleted!`, {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => { }
                    });
                    handleGetItems()
                    setCheckedItems(items.map(() => false))
                    setIsCheckedAllItems(false)
                }
            } catch (error) {
                //(error);
            }

        } else {
            alert('Select any item!')
        }

    }

    const handleToDeleteArea = async () => {

        if (selectedAreas.length > 0) {
            const userConfirmed = window.confirm(`Delete selected area?`);

            if (!userConfirmed) {
                return;
            }
            try {
                const response = await axios.post(`${api_base_url}/deleteAreas/${logginedDB}`, selectedAreas)
                if (response.status === 200) {
                    toast.success(`Successfully deleted!`, {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => { }
                    });
                    fetchData()
                    setCheckedArea(areaInfo.map(() => false))
                    setIsCheckedAll(false)
                }
            } catch (error) {
                //(error);
            }

        } else {
            alert('Select any area!')
        }

    }

    const handleToDeleteTable = async () => {

        if (selectedTables.length > 0) {
            const userConfirmed = window.confirm(`Delete selected table?`);

            if (!userConfirmed) {
                return;
            }
            try {
                const response = await axios.post(`${api_base_url}/deleteTables/${logginedDB}`, selectedTables)
                if (response.status === 200) {
                    toast.success(`Successfully deleted!`, {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => { }
                    });
                    handleGetTables()
                    setCheckedTables(tables.map(() => false))
                    setIsCheckedAllTables(false)
                }
            } catch (error) {
                //(error);
            }

        } else {
            alert('Select any table!')
        }

    }

    const handleToDeleteKitchen = async () => {

        if (selectedKitchen.length > 0) {
            const userConfirmed = window.confirm(`Delete selected kitchen?`);

            if (!userConfirmed) {
                return;
            }
            try {
                const response = await axios.post(`${api_base_url}/deleteKitchens/${logginedDB}`, selectedKitchen)
                if (response.status === 200) {
                    toast.success(`Successfully deleted!`, {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => { }
                    });
                    handleGetKitchen()
                    setCheckedKitchen(loadingKitchen.map(() => false))
                    setIsCheckedAllKitchen(false)
                }
            } catch (error) {
                //(error);
            }

        } else {
            alert('Select any category!')
        }

    }

    const handleToDeleteCategory = async () => {

        if (selectedCategory.length > 0) {
            const userConfirmed = window.confirm(`Delete selected category?`);
            if (!userConfirmed) return;

            try {
                const response = await axios.post(`${api_base_url}/deleteCategories/${logginedDB}`, selectedCategory);

                // Only 2xx responses reach here
                toast.success(`Successfully deleted!`, {
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                });
                handleGetCategories();
                setCheckedCategory(CategoryDbData.map(() => false));
                setIsCheckedAllCategory(false);

            } catch (error) {
                // Handle both 400 and other errors
                if (error.response && error.response.status === 400) {
                    toast.error(`Cannot delete categories that have products registered.`, {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                    });
                } else {
                    // Generic error for other statuses (500, network issues, etc.)
                    console.error('Unexpected error:', error);
                    toast.error('An unexpected error occurred.', { /* options */ });
                }
            }
        } else {
            alert('Select any category!');
        }
    }

    const handleToDeleteSubKitchen = async () => {
        if (selectedSubKitchen.length > 0) {
            const userConfirmed = window.confirm(`Delete selected sub kitchens?`);

            if (!userConfirmed) {
                return;
            }
            try {
                const response = await axios.post(`${api_base_url}/deleteSubKitchens/${logginedDB}`, selectedSubKitchen)
                if (response.status === 200) {
                    toast.success(`Successfully deleted!`, {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => { }
                    });
                    handleGetSubKitchen()
                    setCheckedSubKitchen(loadingSubKitchen.map(() => false))
                    setIsCheckedAllSubKitchen(false)
                }
            } catch (error) {
                //(error);
            }
        } else {
            alert('Select any sub kitchen!')
        }
    }

    const handleToDeleteAddon = async () => {
        if (selectedAddon.length > 0) {
            const userConfirmed = window.confirm(`Delete selected addons?`);

            if (!userConfirmed) {
                return;
            }
            try {
                const response = await axios.post(`${api_base_url}/deleteAddons/${logginedDB}`, selectedAddon)
                if (response.status === 200) {
                    toast.success(`Successfully deleted!`, {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => { }
                    });
                    handleGetAddons()
                    setCheckedAddon(addonsData.map(() => false))
                    setIsCheckedAllAddon(false)
                }
            } catch (error) {
                //(error);
            }
        } else {
            alert('Select any sub kitchen!')
        }
    }

    function formatISODateToDDMMYYYY(isoDateString) {
        const date = new Date(isoDateString); // Convert ISO string to Date object
        const dd = String(date.getDate()).padStart(2, '0'); // Day with leading zero
        const mm = String(date.getMonth() + 1).padStart(2, '0'); // Month with leading zero
        const yyyy = date.getFullYear(); // Year
        return `${dd}-${mm}-${yyyy}`;
    }

    const toEditItem = (item) => {
        navigate('/EditItem', {
            state: { id_productReg: item.id_productReg }
        });
    };


    return (
        <div className='w-full h-full flex flex-col overflow-hidden'>
            <div className='w-full h-max sticky top-0'>
                <NavBarMobile title={'Base Menu'} />
            </div>
            <div className='relative w-full h-full flex bg-[#f5f5f5] overflow-hidden' onClick={(e) => sideNavStateFunc(true)}>
                <div className={`h-full w-max absolute left-0 bg-[#f5f5f5] transition-transform duration-5000 z-[9999] ${sideNavState ? "translate-x-0 ease-out shadow-[5px_5px_100px_rgba(0,0,0,0.4)]" : "-translate-x-full ease-in duration-5000"
                    }`}>
                    <SideNavMob focus={'Menu'} state={sideNav} falseState={(state) => setFalseState(state)} />
                </div>
                <div className='w-full h-full flex flex-col p-3 overflow-hidden relative'>
                    <div className='w-full h-full flex flex-col gap-3 overflow-hidden'>
                        <div className='w-full flex flex-col gap-1 h-max text-[1.1rem] font-nunito font-semibold'>
                            {
                                (!category && !addons && !tableArea && !taxes && !discount && !kitchens) && (
                                    <div className={`w-full flex justify-start items-center relative rounded-t-[.313rem] px-3 py-2 bg-[#fff] ${item ? "rounded-[.313rem]" : ""}`} onClick={toItem}>
                                        <span>Item</span>
                                        <img className='w-[.8rem] absolute right-3' src={item ? uparrow : rightarrow} alt="" />
                                    </div>
                                )
                            }
                            {
                                (!item && !addons && !tableArea && !taxes && !discount && !kitchens) && (
                                    <div className={`w-full flex justify-start items-center relative bg-[#fff] px-3 py-2 ${category ? "rounded-[.313rem]" : ""}`} onClick={toCategory}>
                                        <span>Category</span>
                                        <img className='w-[.8rem] absolute right-3' src={category ? uparrow : rightarrow} alt="" />
                                    </div>
                                )
                            }
                            {
                                (!category && !item && !tableArea && !taxes && !discount && !kitchens) && (
                                    <div className={`w-full flex justify-start items-center relative bg-[#fff] px-3 py-2 ${addons ? "rounded-[.313rem]" : ""}`} onClick={toAddons}>
                                        <span>Addons/Combo</span>
                                        <img className='w-[.8rem] absolute right-3' src={addons ? uparrow : rightarrow} alt="" />
                                    </div>
                                )
                            }
                            {
                                (!category && !addons && !item && !taxes && !discount && !kitchens) && (
                                    <div className={`w-full flex justify-start items-center relative bg-[#fff] px-3 py-2 ${tableArea ? "rounded-[.313rem]" : ""}`} onClick={toTable_Area}>
                                        <span>Tables/Area</span>
                                        <img className='w-[.8rem] absolute right-3' src={tableArea ? uparrow : rightarrow} alt="" />
                                    </div>
                                )
                            }
                            {
                                (!category && !addons && !tableArea && !item && !discount && !kitchens) && (
                                    <div className={`w-full flex justify-start items-center relative bg-[#fff] px-3 py-2 ${taxes ? "rounded-[.313rem]" : ""}`} onClick={toTaxes}>
                                        <span>Taxes</span>
                                        <img className='w-[.8rem] absolute right-3' src={taxes ? uparrow : rightarrow} alt="" />
                                    </div>
                                )
                            }
                            {
                                (!category && !addons && !tableArea && !taxes && !item && !kitchens) && (
                                    <div className={`w-full flex justify-start items-center relative bg-[#fff] px-3 py-2 ${discount ? "rounded-[.313rem]" : ""}`} onClick={toDiscount}>
                                        <span>Discount</span>
                                        <img className='w-[.8rem] absolute right-3' src={discount ? uparrow : rightarrow} alt="" />
                                    </div>
                                )
                            }
                            {
                                (!category && !addons && !tableArea && !taxes && !discount && !item) && (
                                    <div className={`w-full flex justify-start items-center relative rounded-b-[.313rem] px-3 py-2 bg-[#fff] ${kitchens ? "rounded-[.313rem]" : ""}`} onClick={toKitchen}>
                                        <span>Kitchen</span>
                                        <img className='w-[.8rem] absolute right-3' src={kitchens ? uparrow : rightarrow} alt="" />
                                    </div>
                                )
                            }
                        </div>

                        {/*............................................... category ............................................. */}

                        {
                            category && (
                                <div className='h-full flex flex-col gap-1 overflow-hidden'>
                                    <div className='w-full flex flex-col gap-1 h-max text-[1.1rem] font-nunito'>
                                        {
                                            (!categoryCategory && !categoryGrouping && !categoryMenu) && (
                                                <div className={`w-full flex justify-start items-center relative rounded-t-[.313rem] bg-[#fff] px-3 py-2 ${categoryParent ? "rounded-[.313rem]" : ""}`} onClick={toCategoryParent}>
                                                    <span>Parent Category</span>
                                                    <img className='w-[.8rem] absolute right-3' src={categoryParent ? uparrow : rightarrow} alt="" />
                                                </div>
                                            )
                                        }
                                        {
                                            (!categoryParent && !categoryGrouping && !categoryMenu) && (
                                                <div className={`w-full flex justify-start items-center relative bg-[#fff] px-3 py-2 ${categoryCategory ? "rounded-[.313rem]" : ""}`} onClick={toCategoryCategory}>
                                                    <span>Category</span>
                                                    <img className='w-[.8rem] absolute right-3' src={categoryCategory ? uparrow : rightarrow} alt="" />
                                                </div>
                                            )
                                        }
                                        {
                                            (!categoryParent && !categoryCategory && !categoryMenu) && (
                                                <div className={`w-full flex justify-start items-center relative bg-[#fff] px-3 py-2 ${categoryGrouping ? "rounded-[.313rem]" : ""}`} onClick={toCategoryGrouping}>
                                                    <span>Grouping</span>
                                                    <img className='w-[.8rem] absolute right-3' src={categoryGrouping ? uparrow : rightarrow} alt="" />
                                                </div>
                                            )
                                        }
                                        {
                                            (!categoryParent && !categoryCategory && !categoryGrouping) && (
                                                <div className={`w-full flex justify-start items-center relative rounded-b-[.313rem] px-3 py-2 bg-[#fff] ${categoryMenu ? "rounded-[.313rem]" : ""}`} onClick={toCategoryMenu}>
                                                    <span>Menu configaration</span>
                                                    <img className='w-[.8rem] absolute right-3' src={categoryMenu ? uparrow : rightarrow} alt="" />
                                                </div>
                                            )
                                        }
                                    </div>
                                    {categoryCategory && (
                                        <div className='h-full flex flex-col bg-[#fff] rounded-[.313rem] overflow-hidden'>
                                            {
                                                CategoryDbData.length > 0 && (
                                                    <div className='w-full h-max flex p-3 gap-3'>
                                                        <div className='w-full h-full flex border border-[#ccc] rounded-[.313rem]'>
                                                            <div className='flex justify-center items-center p-2'>
                                                                <img className='w-[1rem]' src={Search} alt="?" />
                                                            </div>
                                                            <input className='w-full h-full pr-2 border-none' type="text" placeholder='Search...' />
                                                        </div>
                                                        <div className='w-max flex justify-end items-center font-nunito text-[1rem] text-nowrap'>
                                                            <button className='bg-[#0008B4] text-[#fff] font-[600] rounded-[.313rem] px-3 py-2 focus:outline-none' onClick={() => navigate('/categoryreg')}>Add Category</button>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            {
                                                CategoryDbData.length > 0 ? (
                                                    <div className='relative flex flex-col w-full h-full text-center font-nunito text-[1rem] rounded-[.313rem] overflow-auto noScroll'>
                                                        <div className='sticky top-0 w-full min-h-max flex font-[600] rounded-tl-[.313rem] bg-[#E5E5E5] text-nowrap z-[6666]'>
                                                            <div className='sticky left-0 bg-[#E5E5E5] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[6666]'>
                                                                <input type="checkbox"
                                                                    checked={isCheckedAllCategory}
                                                                    onChange={(e) => handleIsCheckedAll(e, 'category')} />
                                                            </div>
                                                            <div className='min-w-[9rem] max-w-[9rem] p-3 bg-[#E5E5E5] text-left'>Name</div>
                                                            <div className='min-w-[8rem] max-w-[8rem] p-3 bg-[#E5E5E5]'>Created</div>
                                                            <div className='min-w-[8rem] max-w-[8rem] p-3 bg-[#E5E5E5]'>Modified</div>
                                                            <div className='min-w-[7rem] max-w-[7rem] p-3 bg-[#E5E5E5]'>Status</div>
                                                            <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#E5E5E5] z-[6666]'>Action</div>
                                                        </div>
                                                        <div className='flex flex-col w-full z-[6666] text-wrap'>
                                                            {CategoryDbData.map((Category, index) => (
                                                                <div className='flex w-full' key={index}>
                                                                    <div className='sticky left-0 bg-[#fff] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[6666]'>
                                                                        <input type="checkbox"
                                                                            checked={checkedCategory[index]}
                                                                            onChange={(e) =>
                                                                                handleIsChecked(index, e.target.checked, 'category')
                                                                            } />
                                                                    </div>
                                                                    <div className='min-w-[9rem] max-w-[9rem] p-3 text-left'>{Category.Category_Name}</div>
                                                                    <div className='min-w-[8rem] max-w-[8rem] p-3'>{Category.createdDate ? formatISODateToDDMMYYYY(Category.createdDate) : '-'}</div>
                                                                    <div className='min-w-[8rem] max-w-[8rem] p-3'>{Category.modifiedDate ? formatISODateToDDMMYYYY(Category.modifiedDate) : '-'}</div>
                                                                    <div className='min-w-[7rem] max-w-[7rem] p-3 flex justify-center items-center relative'>
                                                                        <input
                                                                            type="checkbox"
                                                                            id="active_inactive_checkbox"
                                                                            checked={isActiveCategory[Category.id_category] || false}
                                                                            readOnly
                                                                        />
                                                                        <div
                                                                            className='active_inactive_div'
                                                                            onClick={() => handleIsActiveCategory(Category.id_category, Category.Status)}
                                                                        ></div>
                                                                    </div>
                                                                    {
                                                                        checkedCategory[index] ? (
                                                                            <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                                                                <img className='w-[1rem] cursor-pointer' src={remove} alt="" onClick={handleToDeleteCategory} />
                                                                            </div>
                                                                        ) : (
                                                                            <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                                                                <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(Category)} />
                                                                                <img className='w-[1rem] cursor-pointer' src={Editing1} alt="" onClick={() => navigate('/categoryreg', {
                                                                                    state: {
                                                                                        id: Category.id_category,
                                                                                        category: Category.Category_Name
                                                                                    }
                                                                                })} />
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='p-3'>Category not registered yet.</div>
                                                )
                                            }
                                        </div>
                                    )}
                                </div>
                            )
                        }

                        {/*............................................... item ............................................. */}

                        {item && (
                            <div className='w-full h-full flex flex-col rounded-[.313rem] bg-[#fff] overflow-hidden'>
                                <div className='w-full h-max flex gap-3 p-3'>
                                    {
                                        items.length > 0 ? (
                                            <div className='w-full h-full'>
                                                <div className='w-full h-full flex border border-[#ccc] rounded-[.313rem]'>
                                                    <div className='flex justify-center items-center p-2'>
                                                        <img className='w-[1rem]' src={Search} alt="?" />
                                                    </div>
                                                    <input className='w-full h-full pr-2 border-none' type="text" placeholder='Search...' />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className='w-full font-nunito flex justify-start items-center'>Item not registered yet.</div>
                                        )
                                    }
                                    <div className='w-max flex justify-end items-center font-nunito text-[1rem] text-nowrap'>
                                        <button className='bg-[#0008B4] text-[#fff] font-[600] rounded-[.313rem] px-3 py-2 focus:outline-none' onClick={toAddItem}>Add Item</button>
                                    </div>
                                </div>
                                {
                                    items.length > 0 && (
                                        <div className='relative flex flex-col w-full h-full text-center font-nunito text-[1rem] rounded-[.313rem] overflow-auto noScroll'>
                                            <div className='sticky top-0 w-full min-h-max flex font-[600] rounded-tl-[.313rem] bg-[#E5E5E5] text-nowrap z-[7777]'>
                                                <div className='sticky left-0 bg-[#E5E5E5] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[7777]'>
                                                    <input type="checkbox"
                                                        checked={isCheckedAllItems}
                                                        onChange={(e) => handleIsCheckedAll(e, 'items')} />
                                                </div>
                                                <div className='min-w-[5rem] max-w-[5rem] p-3 bg-[#E5E5E5]'>Image</div>
                                                <div className='min-w-[10rem] max-w-[10rem] p-3 bg-[#E5E5E5] text-left'>Name</div>
                                                <div className='min-w-[7rem] max-w-[7rem] p-3 bg-[#E5E5E5]'>Item Code</div>
                                                <div className='min-w-[6rem] max-w-[6rem] p-3 bg-[#E5E5E5]'>Price</div>
                                                <div className='min-w-[8rem] max-w-[8rem] p-3 bg-[#E5E5E5]'>Description</div>
                                                <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#E5E5E5] z-[7777]'>Action</div>
                                            </div>
                                            <div className='flex flex-col w-full z-[6666] text-wrap'>
                                                {items.map((item, index) => (
                                                    <div key={index} className='flex w-full'>
                                                        <div className='sticky left-0 bg-[#fff] min-w-[3rem] p-3 flex justify-center items-center z-[6666]'>
                                                            <input type="checkbox"
                                                                checked={checkedItems[index]}
                                                                onChange={(e) =>
                                                                    handleIsChecked(index, e.target.checked, 'items')
                                                                } />
                                                        </div>
                                                        <div className='min-w-[5rem] max-w-[5rem] p-3 flex justify-center items-center'>
                                                            <img className='table_item_AddImg' src={`${api_base_url}/uploads/${customerCode}/${logginedDB}/items/${item.imgName}`} alt="" onClick={() => handleImageClick(`${api_base_url}/uploads/${customerCode}/${logginedDB}/items/${item.imgName}`)} />
                                                        </div>
                                                        <div className='min-w-[10rem] max-w-[10rem] p-3 text-left flex justify-start items-center'>{item.productName}</div>
                                                        <div className='min-w-[7rem] max-w-[7rem] p-3 flex justify-center items-center'>{item.itemCode}</div>
                                                        <div className='min-w-[6rem] max-w-[6rem] p-3 flex justify-center items-center'>{item.rate}</div>
                                                        <div className='min-w-[8rem] max-w-[8rem] p-3 flex justify-center items-center'>descr</div>
                                                        {
                                                            checkedItems[index] ? (
                                                                <div className='sticky right-0 bg-[#fff] min-w-[7rem] miax-w-[7rem] p-3 flex justify-center items-center gap-2 z-[6666]'>
                                                                    <img className='w-[1rem] cursor-pointer' src={remove} alt="" onClick={handleToDeleteItem} />
                                                                </div>
                                                            ) : (
                                                                <div className='w-2/12 p-3 flex justify-center items-center gap-2'>
                                                                    <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt=""
                                                                        onClick={() => handleToView(item)} />
                                                                    <img className='w-[1rem] cursor-pointer'
                                                                        src={Editing1} alt=""
                                                                        onClick={() => toEditItem(item)}
                                                                    />
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        )}
                        {modalImage && (
                            <ModalImage imageUrl={modalImage} onClose={closeModal} mobile={modalImageMob} />
                        )}

                        {/* ..........................................................addon.................................................. */}

                        {addons && (
                            <div className='h-full flex flex-col bg-[#fff] rounded-[.313rem] overflow-hidden'>
                                <div className='w-full h-max flex p-3 gap-3'>
                                    {
                                        addonsData.length > 0 ? (
                                            <div className='w-full h-full flex border border-[#ccc] rounded-[.313rem]'>
                                                <div className='flex justify-center items-center p-2'>
                                                    <img className='w-[1rem]' src={Search} alt="?" />
                                                </div>
                                                <input className='w-full h-full pr-2 border-none' type="text" placeholder='Search...' />
                                            </div>
                                        ) : (
                                            <div className='w-1/2 font-nunito flex justify-start items-center'>Addons/Combo not registered yet.</div>
                                        )
                                    }
                                    <div className='w-max flex justify-end items-center font-nunito text-[1rem] text-nowrap'>
                                        <button className='bg-[#0008B4] text-[#fff] font-[600] rounded-[.313rem] px-3 py-2 focus:outline-none' onClick={toAddAddon}>Add Addon</button>
                                    </div>
                                </div>
                                {
                                    addonsData.length > 0 && (
                                        <div className='relative flex flex-col w-full h-full text-center font-nunito text-[1rem] rounded-[.313rem] overflow-auto noScroll'>
                                            <div className='sticky top-0 w-full min-h-max flex font-[600] rounded-tl-[.313rem] bg-[#E5E5E5] text-nowrap z-[7777]'>
                                                <div className='sticky left-0 bg-[#E5E5E5] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[7777]'>
                                                    <input type="checkbox"
                                                        checked={isCheckedAllAddon}
                                                        onChange={(e) => handleIsCheckedAll(e, 'addon')} />
                                                </div>
                                                <div className='min-w-[5rem] max-w-[5rem] p-3 bg-[#E5E5E5]'>Image</div>
                                                <div className='min-w-[9rem] max-w-[9rem] p-3 bg-[#E5E5E5] flex justify-start items-center'>Name</div>
                                                <div className='min-w-[8rem] max-w-[8rem] p-3 bg-[#E5E5E5]'>Price</div>
                                                <div className='min-w-[7rem] max-w-[7rem] p-3 bg-[#E5E5E5]'>Status</div>
                                                <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#E5E5E5] z-[7777]'>Action</div>
                                            </div>
                                            <div className='flex flex-col w-full z-[6666] text-wrap'>
                                                {addonsData.map((addon, index) => (
                                                    <div key={index} className='flex w-full'>
                                                        <div className='sticky left-0 bg-[#fff] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[6666]'>
                                                            <input type="checkbox"
                                                                checked={checkedAddon[index]}
                                                                onChange={(e) =>
                                                                    handleIsChecked(index, e.target.checked, 'addon')
                                                                } />
                                                        </div>
                                                        <div className='min-w-[5rem] max-w-[5rem] p-3 flex justify-center items-center'>
                                                            <img className='table_item_AddImg' src={`${api_base_url}/uploads/${customerCode}/${logginedDB}/addons/${addon.imgName}`} alt="" onClick={() => handleImageClick(`${api_base_url}/uploads/${customerCode}/${logginedDB}/addons/${addon.imgName}`)} />
                                                        </div>
                                                        <div className='min-w-[9rem] max-w-[9rem] p-3 flex justify-start items-center'>{addon.addon_name}</div>
                                                        <div className='min-w-[8rem] max-w-[8rem] p-3 flex justify-center items-center'>₹ {addon.addon_rate}</div>
                                                        <div className='min-w-[7rem] max-w-[7rem] p-3 flex justify-center items-center relative'>
                                                            <input
                                                                type="checkbox"
                                                                id="active_inactive_checkbox"
                                                                checked={isActiveAddon[addon.id_addon] || false}
                                                                readOnly
                                                            />
                                                            <div
                                                                className='active_inactive_div'
                                                                onClick={() => handleIsActiveAddon(addon.id_addon, addon.Status)}
                                                            ></div>
                                                        </div>
                                                        {
                                                            checkedAddon[index] ? (
                                                                <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                                                    <img className='w-[1rem] cursor-pointer' src={remove} alt="" onClick={handleToDeleteAddon} />
                                                                </div>
                                                            ) : (
                                                                <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                                                    <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(addon)} />
                                                                    <img className='w-[1rem] cursor-pointer' src={Editing1} alt="" onClick={() => navigate('/addonreg', {
                                                                        state: {
                                                                            id: addon.id_addon,
                                                                            area: addon.addon_name
                                                                        }
                                                                    })} />
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        )}

                        {/*................................................. tableArea................................................................. */}

                        {tableArea && (
                            <div className='overflow-hidden flex flex-col gap-1 w-full h-full'>
                                <div className='w-full flex flex-col gap-1 h-max text-[1.1rem] font-nunito'>
                                    {
                                        (!tableArea_Tables) && (
                                            <div className={`w-full flex justify-start items-center relative rounded-t-[.313rem] bg-[#fff] px-3 py-2 ${tableArea_Areas ? "rounded-[.313rem]" : ""}`} onClick={toTableArea_Areas}>
                                                <span>Areas</span>
                                                <img className='w-[.8rem] absolute right-3' src={tableArea_Areas ? uparrow : rightarrow} alt="" />
                                            </div>
                                        )
                                    }
                                    {
                                        (!tableArea_Areas) && (
                                            <div className={`w-full flex justify-start items-center relative rounded-b-[.313rem] px-3 py-2 bg-[#fff] ${tableArea_Tables ? "rounded-[.313rem]" : ""}`} onClick={toTableArea_Tables}>
                                                <span>Tables</span>
                                                <img className='w-[.8rem] absolute right-3' src={tableArea_Tables ? uparrow : rightarrow} alt="" />
                                            </div>
                                        )
                                    }
                                </div>
                                {tableArea_Areas && areaInfo.length > 0 ? (
                                    <div className='h-full flex flex-col bg-[#fff] rounded-[.313rem] overflow-hidden'>
                                        <div className='w-full h-max flex p-3 gap-3'>
                                            <div className='w-full h-full flex border border-[#ccc] rounded-[.313rem]'>
                                                <div className='flex justify-center items-center p-2'>
                                                    <img className='w-[1rem]' src={Search} alt="?" />
                                                </div>
                                                <input className='w-full h-full pr-2 border-none' type="text" placeholder='Search...' />
                                            </div>
                                            <div className='w-max flex justify-end items-center font-nunito text-[1rem] text-nowrap'>
                                                <button className='bg-[#0008B4] text-[#fff] font-[600] rounded-[.313rem] px-3 py-2 focus:outline-none' onClick={toAddArea}>Add Area</button>
                                            </div>
                                        </div>
                                        <div className='relative flex flex-col w-full h-full text-center font-nunito text-[1rem] rounded-[.313rem] overflow-auto noScroll'>
                                            <div className='sticky top-0 w-full min-h-max flex font-[600] rounded-tl-[.313rem] bg-[#E5E5E5] text-nowrap z-[7777]'>
                                                <div className='sticky left-0 bg-[#E5E5E5] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[7777]'>
                                                    <input type="checkbox"
                                                        checked={isCheckedAll}
                                                        onChange={(e) => handleIsCheckedAll(e, 'area')} />
                                                </div>
                                                <div className='min-w-[9rem] max-w-[9rem] p-3 bg-[#E5E5E5] text-left'>Area Name</div>
                                                <div className='min-w-[8rem] max-w-[8rem] p-3 bg-[#E5E5E5]'>Tables</div>
                                                <div className='min-w-[8rem] max-w-[8rem] p-3 bg-[#E5E5E5]'>Created Date</div>
                                                <div className='min-w-[8rem] max-w-[8rem] p-3 bg-[#E5E5E5]'>Modified Date</div>
                                                <div className='min-w-[7rem] max-w-[7rem] p-3 bg-[#E5E5E5]'>Status</div>
                                                <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#E5E5E5] z-[7777]'>Action</div>
                                            </div>
                                            <div className='flex flex-col w-full z-[6666] text-wrap'>
                                                {areaInfo.map((area, index) => (
                                                    <div className='flex' key={index}>
                                                        <div className='sticky left-0 bg-[#fff] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[6666]'>
                                                            <input type="checkbox"
                                                                checked={checkedArea[index]}
                                                                onChange={(e) =>
                                                                    handleIsChecked(index, e.target.checked, 'area')
                                                                } />
                                                        </div>
                                                        <div className='min-w-[9rem] max-w-[9rem] p-3 text-left'>{area.AreaName}</div>
                                                        <div className='min-w-[8rem] max-w-[8rem] p-3'>{area.AreaTables}</div>
                                                        {/* <div className='p-3 w-2/12'>{area.Status}</div> */}
                                                        <div className='min-w-[8rem] max-w-[8rem] p-3'>{area.createdDate ? formatDate(area.createdDate) : '-'}</div>
                                                        <div className='min-w-[8rem] max-w-[8rem] p-3'>{area.modifiedDate ? formatDate(area.modifiedDate) : '-'}</div>
                                                        <div className='min-w-[7rem] max-w-[7rem] p-3 flex justify-center items-center relative'>
                                                            <input
                                                                type="checkbox"
                                                                id="active_inactive_checkbox"
                                                                checked={isActive[area.Area_id] || false}
                                                                readOnly
                                                            />
                                                            <div
                                                                className='active_inactive_div'
                                                                onClick={() => handleIsActive(area.Area_id, area.Status)}
                                                            ></div>
                                                        </div>
                                                        {
                                                            checkedArea[index] ? (
                                                                <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                                                    <img className='w-[1rem] cursor-pointer' src={remove} alt="" onClick={handleToDeleteArea} />
                                                                </div>
                                                            ) : (
                                                                <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                                                    <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(item)} />
                                                                    <img className='w-[1rem] cursor-pointer' src={Editing1} alt="" onClick={() => navigate('/tableareareg', {
                                                                        state: {
                                                                            id: area.Area_id,
                                                                            area: area.AreaName
                                                                        }
                                                                    })} />
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ) : tableArea_Areas && (
                                    <div className='w-full h-full flex p-3 bg-[#fff] rounded-[.313rem] font-nunito text-nowrap justify-center items-start'>
                                        <div className='w-full flex just items-center'>
                                            <span className='w-full'>Area not yet registered.</span>
                                            <button className='w-max bg-[#0008B4] text-[#fff] font-[600] rounded-[.313rem] px-3 py-2 focus:outline-none' onClick={toAddArea}>Add Area</button>
                                        </div>
                                    </div>
                                )}
                                {tableArea_Tables && (
                                    <div className='h-full flex flex-col rounded-[.313rem] bg-[#fff] overflow-hidden'>
                                        <div className='w-full h-max flex p-3 gap-3'>
                                            <div className="w-full">
                                                <Select
                                                    styles={customStyles}
                                                    placeholder='Area'
                                                    value={selectedOption}
                                                    options={options}
                                                    onChange={(selectedOption) => handleChange(selectedOption)}
                                                // components={{ 
                                                // 	Option: CustomOption,
                                                // 	SingleValue: CustomSingleValue, 
                                                // 	Placeholder: CustomPlaceholder
                                                // }}
                                                // isDisabled={true}
                                                />
                                            </div>
                                            <div className='w-max flex justify-end items-center font-nunito text-[1rem] text-nowrap'>
                                                <button className='bg-[#0008B4] text-[#fff] font-[600] rounded-[.313rem] px-3 py-2 focus:outline-none' onClick={toAddTable}>Add Table</button>
                                            </div>
                                        </div>
                                        {
                                            (selectedOption && tables.length > 0) ? (
                                                <div className='relative flex flex-col w-full h-full text-center font-nunito text-[1rem] rounded-[.313rem] overflow-auto noScroll'>
                                                    <div className='sticky top-0 w-full min-h-max flex font-[600] rounded-tl-[.313rem] bg-[#E5E5E5] text-nowrap z-[7777]'>
                                                        <div className='sticky left-0 bg-[#E5E5E5] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[7777]'>
                                                            <input type="checkbox"
                                                                checked={isCheckedAllTables}
                                                                onChange={(e) => handleIsCheckedAll(e, 'table')} />
                                                        </div>
                                                        <div className='min-w-[5rem] max-w-[5rem] p-3 bg-[#E5E5E5]'>Table</div>
                                                        <div className='min-w-[6rem] max-w-[6rem] p-3 bg-[#E5E5E5]'>Persons</div>
                                                        {/* <div className='p-3 w-2/12'>Info</div> */}
                                                        <div className='min-w-[8rem] max-w-[8rem] p-3 bg-[#E5E5E5]'>Created Date</div>
                                                        <div className='min-w-[8rem] max-w-[8rem] p-3 bg-[#E5E5E5]'>Modified Date</div>
                                                        <div className='min-w-[9rem] max-w-[9rem] p-3 bg-[#E5E5E5] text-left'>Name</div>
                                                        {/* <div className='p-3 w-2/12'>Area</div> */}
                                                        <div className='min-w-[10rem] max-w-[10rem] p-3 bg-[#E5E5E5]'>Status</div>
                                                        <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#E5E5E5] z-[7777]'>Action</div>
                                                    </div>
                                                    <div className='flex flex-col w-full z-[6666] text-wra'>
                                                        {tables.map((table, index) => (
                                                            <div className='flex' key={index}>
                                                                <div className='sticky left-0 bg-[#fff] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[6666]'>
                                                                    <input type="checkbox"
                                                                        checked={checkedTables[index]}
                                                                        onChange={(e) =>
                                                                            handleIsChecked(index, e.target.checked, 'table')
                                                                        } />
                                                                </div>
                                                                <div className='min-w-[5rem] max-w-[5rem] p-3'>{table.Table_num}</div>
                                                                <div className='min-w-[6rem] max-w-[6rem] p-3'>{table.Table_Capacity}</div>
                                                                {/* <div className='p-3 w-2/12 truncate'>{table.Table_info}</div> */}
                                                                <div className='min-w-[8rem] max-w-[8rem] p-3'>{table.createdDate ? formatDate(table.createdDate) : '-'}</div>
                                                                <div className='min-w-[8rem] max-w-[8rem] p-3'>{table.modifiedDate ? formatDate(table.modifiedDate) : '-'}</div>
                                                                <div className='min-w-[9rem] max-w-[9rem] p-3 text-left'>{table.Table_onlineName}</div>
                                                                {
                                                                    table.Table_Status === 1 ? (
                                                                        <div className='min-w-[10rem] max-w-[10rem] p-3 flex justify-center items-center relative'>
                                                                            <input
                                                                                type="checkbox"
                                                                                id="active_inactive_checkbox"
                                                                                checked={isActiveTable[table.Table_id] || false}
                                                                                readOnly
                                                                            />
                                                                            <div
                                                                                className='active_inactive_div'
                                                                                onClick={() => handleIsActiveTable(table.Table_id, table.Status)}
                                                                            ></div>
                                                                        </div>
                                                                    ) : table.Table_Status === 2 ? (
                                                                        <div className='min-w-[10rem] max-w-[10rem] p-3 flex justify-center items-center'>
                                                                            <span className='text-[#29C65D] font-lato font-[500]'>Running Table</span>
                                                                        </div>
                                                                    ) : table.Table_Status === 3 ? (
                                                                        <div className='min-w-[10rem] max-w-[10rem] p-3 flex justify-center items-center'>
                                                                            <span className='text-[#E5E918] font-lato font-[500]'>Printed Table</span>
                                                                        </div>
                                                                    ) : table.Table_Status === 4 ? (
                                                                        <div className='min-w-[10rem] max-w-[10rem] p-3 flex justify-center items-center'>
                                                                            <span className='text-[#744D29] font-lato font-[500]'>Running KOT</span>
                                                                        </div>
                                                                    ) : table.Table_Status === 5 && (
                                                                        <div className='min-w-[10rem] max-w-[10rem] p-3 flex justify-center items-center'>
                                                                            <span className='text-[#FF001F] font-lato font-[500]'>Reserved</span>
                                                                        </div>
                                                                    )
                                                                }
                                                                {
                                                                    checkedTables[index] ? (
                                                                        <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                                                            <img className='w-[1rem] cursor-pointer' src={remove} alt="" onClick={handleToDeleteTable} />
                                                                        </div>
                                                                    ) : (
                                                                        <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                                                            <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(table)} />
                                                                            <img className='w-[1rem] cursor-pointer' src={Editing1} alt="" onClick={() => navigate('/tablereg', {
                                                                                state: {
                                                                                    id: table.Table_id,
                                                                                    area: selectedOption.label
                                                                                }
                                                                            })} />
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : (selectedOption && tables.length < 1) ? (
                                                <div className='p-3 font-nunito'>Table not yet registered.</div>
                                            ) : (!selectedOption && tableArea_Tables) && (
                                                <div className='p-3 font-[500] font-nunito'>Please select your preferred area.</div>
                                            )
                                        }
                                    </div>
                                )}
                            </div>
                        )}

                        {/*................................................. Kitchen .................................................................. */}

                        {kitchens && (
                            <div className='overflow-hidden flex flex-col gap-1 w-full h-full'>
                                <div className='w-full flex flex-col gap-1 h-max text-[1.1rem] font-nunito'>
                                    {
                                        (!SubKitchenTab) && (
                                            <div className={`w-full flex justify-start items-center relative rounded-t-[.313rem] bg-[#fff] px-3 py-2 ${KitchenTab ? "rounded-[.313rem]" : ""}`} onClick={toKitchenTab}>
                                                <span>Kitchen</span>
                                                <img className='w-[.8rem] absolute right-3' src={KitchenTab ? uparrow : rightarrow} alt="" />
                                            </div>
                                        )
                                    }
                                    {
                                        (!KitchenTab) && (
                                            <div className={`w-full flex justify-start items-center relative rounded-b-[.313rem] px-3 py-2 bg-[#fff] ${SubKitchenTab ? "rounded-[.313rem]" : ""}`} onClick={toSubKitchenTab}>
                                                <span>Sub Kitchen</span>
                                                <img className='w-[.8rem] absolute right-3' src={SubKitchenTab ? uparrow : rightarrow} alt="" />
                                            </div>
                                        )
                                    }
                                </div>

                                {KitchenTab && (
                                    <div className='h-full flex flex-col bg-[#fff] rounded-[.313rem] overflow-hidden'>
                                        {
                                            loadingKitchen.length > 0 && (
                                                <div className='w-full h-max flex p-3 gap-3'>
                                                    <div className='w-full h-full flex border border-[#ccc] rounded-[.313rem]'>
                                                        <div className='flex justify-center items-center p-2'>
                                                            <img className='w-[1rem]' src={Search} alt="?" />
                                                        </div>
                                                        <input className='w-full h-full pr-2 border-none' type="text" placeholder='Search...' />
                                                    </div>
                                                    <div className='w-max flex justify-end items-center font-nunito text-[1rem] text-nowrap'>
                                                        <button className='bg-[#0008B4] text-[#fff] font-[600] rounded-[.313rem] px-3 py-2 focus:outline-none' onClick={() => navigate('/Kitchen')}>Add Kitchen</button>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            (loadingKitchen.length > 0) ? (
                                                <div className='relative flex flex-col w-full h-full text-center font-nunito text-[1rem] rounded-[.313rem] overflow-auto noScroll'>
                                                    <div className='sticky top-0 w-full min-h-max flex font-[600] rounded-tl-[.313rem] bg-[#E5E5E5] text-nowrap z-[7777]'>
                                                        <div className='sticky left-0 bg-[#E5E5E5] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[7777]'>
                                                            <input type="checkbox"
                                                                checked={isCheckedAllKitchen}
                                                                onChange={(e) => handleIsCheckedAll(e, 'kitchen')} />
                                                        </div>
                                                        <div className='min-w-[9rem] max-w-[9rem] p-3 bg-[#E5E5E5] text-left'>Name</div>
                                                        <div className='min-w-[6rem] max-w-[6rem] p-3 bg-[#E5E5E5]'>Code</div>
                                                        <div className='min-w-[7rem] max-w-[7rem] p-3 bg-[#E5E5E5]'>Status</div>
                                                        <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#E5E5E5] z-[7777]'>Action</div>
                                                    </div>
                                                    <div className='flex flex-col w-full z-[6666] text-wrap'>
                                                        {loadingKitchen.map((kitchen, index) => (
                                                            <div className='flex' key={index}>
                                                                <div className='sticky left-0 bg-[#fff] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[6666]'>
                                                                    <input type="checkbox"
                                                                        checked={checkedKitchen[index]}
                                                                        onChange={(e) =>
                                                                            handleIsChecked(index, e.target.checked, 'kitchen')
                                                                        } />
                                                                </div>
                                                                <div className='min-w-[9rem] max-w-[9rem] p-3 text-left'>{kitchen.KitchenName}</div>
                                                                <div className='min-w-[6rem] max-w-[6rem] p-3'>{kitchen.KitchenCode}</div>
                                                                <div className='min-w-[7rem] max-w-[7rem] p-3 flex justify-center items-center relative'>
                                                                    <input
                                                                        type="checkbox"
                                                                        id="active_inactive_checkbox"
                                                                        checked={isActiveKitchen[kitchen.Kitchen_id] || false}
                                                                        readOnly
                                                                    />
                                                                    <div
                                                                        className='active_inactive_div'
                                                                        onClick={() => handleIsActiveKitchen(kitchen.Kitchen_id, kitchen.Kitchen_is_Active)}
                                                                    ></div>
                                                                </div>
                                                                {
                                                                    checkedKitchen[index] ? (
                                                                        <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                                                            <img className='w-[1rem] cursor-pointer' src={remove} alt="" onClick={handleToDeleteKitchen} />
                                                                        </div>
                                                                    ) : (
                                                                        <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                                                            <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(kitchen)} />
                                                                            <img className='w-[1rem] cursor-pointer' src={Editing1} alt="" onClick={() => navigate('/Kitchen', {
                                                                                state: {
                                                                                    id: kitchen.Kitchen_id,
                                                                                    kitchen: kitchen.KitchenName
                                                                                }
                                                                            })} />
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className='w-full h-full flex p-3 bg-[#fff] rounded-[.313rem] font-nunito text-nowrap justify-center items-start'>
                                                    <div className='w-full flex just items-center'>
                                                        <span className='w-full'>Kitchen not yet registered.</span>
                                                        <button className='w-max bg-[#0008B4] text-[#fff] font-[600] rounded-[.313rem] px-3 py-2 focus:outline-none' onClick={() => navigate('/Kitchen')}>Add Kitchen</button>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                )}

                                {SubKitchenTab && (
                                    <div className='h-full flex flex-col bg-[#fff] rounded-[.313rem] overflow-hidden'>
                                        {
                                            loadingSubKitchen.length > 0 && (
                                                <div className='w-full h-max flex p-3 gap-3'>
                                                    <div className='w-full h-full flex border border-[#ccc] rounded-[.313rem]'>
                                                        <div className='flex justify-center items-center p-2'>
                                                            <img className='w-[1rem]' src={Search} alt="?" />
                                                        </div>
                                                        <input className='w-full h-full pr-2 border-none' type="text" placeholder='Search...' />
                                                    </div>
                                                    <div className='w-max flex justify-end items-center font-nunito text-[1rem] text-nowrap'>
                                                        <button className='bg-[#0008B4] text-[#fff] font-[600] rounded-[.313rem] px-3 py-2 focus:outline-none' onClick={() => navigate('/SubKitchen')}>Add SubKitchen</button>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            (loadingSubKitchen.length > 0) ? (
                                                <div className='relative flex flex-col w-full h-full text-center font-nunito text-[1rem] rounded-[.313rem] overflow-auto noScroll'>
                                                    <div className='sticky top-0 w-full min-h-max flex font-[600] rounded-tl-[.313rem] bg-[#E5E5E5] text-nowrap z-[7777]'>
                                                        <div className='sticky left-0 bg-[#E5E5E5] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[7777]'>
                                                            <input type="checkbox"
                                                                checked={isCheckedAllSubKitchen}
                                                                onChange={(e) => handleIsCheckedAll(e, 'subKitchen')} />
                                                        </div>
                                                        <div className='min-w-[9rem] max-w-[9rem] p-3 bg-[#E5E5E5] text-left'>Name</div>
                                                        <div className='min-w-[6rem] max-w-[6rem] p-3 bg-[#E5E5E5]'>Code</div>
                                                        <div className='min-w-[7rem] max-w-[7rem] p-3 bg-[#E5E5E5]'>Status</div>
                                                        <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#E5E5E5] z-[7777]'>Action</div>
                                                    </div>
                                                    <div className='flex flex-col w-full z-[6666] text-wrap'>
                                                        {loadingSubKitchen.map((kitchen, index) => (
                                                            <div className='flex' key={index}>
                                                                <div className='sticky left-0 bg-[#fff] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[6666]'>
                                                                    <input type="checkbox"
                                                                        checked={checkedSubKitchen[index]}
                                                                        onChange={(e) =>
                                                                            handleIsChecked(index, e.target.checked, 'subKitchen')
                                                                        } />
                                                                </div>
                                                                <div className='min-w-[9rem] max-w-[9rem] p-3 text-left'>{kitchen.SubKitchenName}</div>
                                                                <div className='min-w-[6rem] max-w-[6rem] p-3'>{kitchen.KitchenCode}</div>
                                                                <div className='min-w-[7rem] max-w-[7rem] p-3 flex justify-center items-center relative'>
                                                                    <input
                                                                        type="checkbox"
                                                                        id="active_inactive_checkbox"
                                                                        checked={isActiveSubKitchen[kitchen.Sub_Kitchen_id] || false}
                                                                        readOnly
                                                                    />
                                                                    <div
                                                                        className='active_inactive_div'
                                                                        onClick={() => handleIsActiveSubKitchen(kitchen.Sub_Kitchen_id, kitchen.Sub_Kitchen_is_Active)}
                                                                    ></div>
                                                                </div>
                                                                {
                                                                    checkedSubKitchen[index] ? (
                                                                        <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                                                            <img className='w-[1rem] cursor-pointer' src={remove} alt="" onClick={handleToDeleteSubKitchen} />
                                                                        </div>
                                                                    ) : (
                                                                        <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                                                            <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(item)} />
                                                                            <img className='w-[1rem] cursor-pointer' src={Editing1} alt="" onClick={() => navigate('/SubKitchen', {
                                                                                state: {
                                                                                    id: kitchen.Sub_Kitchen_id,
                                                                                    kitchen: kitchen.SubKitchenName
                                                                                }
                                                                            })} />
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className='w-full h-full flex p-3 bg-[#fff] rounded-[.313rem] font-nunito text-nowrap justify-center items-start'>
                                                    <div className='w-full flex just items-center'>
                                                        <span className='w-full text-wrap'>Sub Kitchen not yet registered.</span>
                                                        <button className='w-max bg-[#0008B4] text-[#fff] font-[600] rounded-[.313rem] px-3 py-2 focus:outline-none' onClick={() => navigate('/SubKitchen')}>Add SubKitchen</button>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    {viewDetails && (
                        <div
                            className={`absolute right-0 h-full w-max pl-3 pr-0 pt-3 pb-3 flex justify-center items-center bg-transparent gap-2 ${isExiting ? "slide-out" : "slide-in"
                                }`}>
                            <div
                                className="h-8 w-max flex justify-center items-center pl-1 pr-1 pt-2 pb-2 bg-[#464545] cursor-pointer transition-all duration-300 hover:h-16"
                                onClick={handleClose}>
                                <img className="w-[.5rem] h-[1rem]" src={right} alt="" />
                            </div>
                            <div className="w-[30rem] rounded-l-lg shadow-2xl border-l-2 border-t bg-[#f8f8f8] h-full">
                                {/* {viewUserDetails} */}hiiiiiiiiiiiiiiii
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {/* {addVarient && (
                <div className='AddVarientModel'>
                    <div className='AddVarientModelDiv' ref={parentRef}>
                        <AddVarientModel 
                            onClose={() => {
                                setAddVarient(false)
                            }}
                            parentRef={parentRef}/>
                    </div>
                </div>
            )} */}
        </div>
    )
}

export default BaseMenuRegMob
